import styles from "./Question.module.scss";
import Answer from "../Answer/Answer";
import classNames from "classnames";
import MoreInfoAccordion from "../MoreInfoAccordion/MoreInfoAccordion";
import { QuestionInfo } from "../types";
import { useState } from "react";

type Props = {
  id: string;
  step: string;
  question: string;
  information?: QuestionInfo;
  onAnswered: (id: string, answer: boolean) => void;
};

type AnswerValue = "" | "yes" | "no";

const Question = ({ step, id, question, information, onAnswered }: Props) => {
  const [answer, setAnswer] = useState<AnswerValue>("");

  const handleAnswer = (id: string, answeredYes: boolean) => {
    onAnswered(id, answeredYes);
    setAnswer(answeredYes ? "yes" : "no");
  };

  return (
    <div
      className={classNames(
        styles.question,
        information?.gradingHelps.length && styles["question--with-info"],
      )}
      key={id}
    >
      <div className={styles.question__wrapper}>
        <h4 className={styles.question__text}>
          <span className={styles.question__step}>{step}</span>
          {question}
        </h4>
        <div className={styles.question__answers}>
          <Answer
            label="Yes"
            onSelect={() => handleAnswer(id, true)}
            selected={answer === "yes"}
          />
          <Answer
            label="No"
            onSelect={() => handleAnswer(id, false)}
            selected={answer === "no"}
          />
        </div>
      </div>

      {information && <MoreInfoAccordion {...information} />}
    </div>
  );
};

export default Question;
